import React, { useEffect, useState, useRef } from 'react';
import {
  Avatar,
  Box,
  Button,
  Container,
  CircularProgress,
  Theme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ArrowRight } from '@material-ui/icons';

import Header from '../components/Header';
import Section from '../components/Section';
import Title from '../components/Title';
import PostList from '../components/PostList';
import PreFooter from '../components/PreFooter';
import Footer from '../components/Footer';

import { fetchPosts, convertDocsToPosts } from '../services/posts';
import VideoPlayer from '../components/VideoPlayer';
import TextSearchField from '../components/TextSearchField';
import { getKeywords } from '../services/filter';

const initialVideoState = { open: false, url: '' };
const postType = 'video';
const postLength = 9;
const loadMoreLength = 6;

const useStyles = makeStyles((theme: Theme) => ({
  moreButton: {
    backgroundColor: '#7683F9',
    borderRadius: 16,
    color: 'white',
    paddingLeft: 32,
    paddingRight: 32,
  },
  loadProgress: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const Video = () => {
  const { moreButton, loadProgress } = useStyles();
  const [initLoading, setInitLoading] = useState(true);
  const [posts, setPosts] = useState<Post[]>([]);
  const lastVisibleRef = useRef<FirestoreDocument>();
  const [loadMoreAble, setLoadMoreAble] = useState(true);
  const [loading, setLoading] = useState(false);
  const [videoState, setVideoState] = useState<IVideoState>(initialVideoState);
  const [query, setQuery] = useState('');
  useEffect(() => {
    const fetchData = async () => {
      const data = await fetchPosts(postType, postLength);
      setPosts(convertDocsToPosts(data.docs));
      lastVisibleRef.current = data.docs[data.docs.length - 1];
      setLoadMoreAble(data.hasOtherPage);
      setInitLoading(false);
    };
    fetchData();
  }, []);
  const handleClickShowMore = async () => {
    setLoading(true);
    const data = await fetchPosts(
      postType,
      loadMoreLength,
      [],
      lastVisibleRef.current
    );
    setPosts((state) => [...state, ...convertDocsToPosts(data.docs)]);
    lastVisibleRef.current = data.docs[data.docs.length - 1];
    setLoadMoreAble(data.hasOtherPage);
    setLoading(false);
  };
  const searchPosts = (query: string) => {
    const keywords = getKeywords(query);
    if (keywords.length === 0) return posts;
    return posts.filter(
      (post) =>
        keywords.some((keyword) =>
          post.title.toLowerCase().includes(keyword)
        ) ||
        keywords.some((keyword) => post.excerpt.toLowerCase().includes(keyword))
    );
  };
  const filteredPosts = () => {
    return searchPosts(query).map((v) => v as Post);
  };
  const handleTextSearch = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    event.persist();
    setQuery(event.target.value);
  };
  return (
    <>
      <Header />
      <Container maxWidth="md">
        <VideoPlayer
          open={videoState.open}
          url={videoState.url}
          onClose={() => {
            setVideoState((state) => ({ ...state, open: false }));
          }}
        />
        <Section>
          <Box display="flex" justifyContent="space-between">
            <Title
              title="วิดีโอ"
              subtitle="รู้จัก Cyber Security ให้ดีขึ้น ด้วยวิดีโอสั้น"
              align="left"
            />
            <TextSearchField
              value={query}
              onChange={handleTextSearch}
              onClear={() => setQuery('')}
              filled={true}
            />
          </Box>
          <Box height={16} />
          <PostList
            posts={filteredPosts()}
            column={3}
            icon={
              <Avatar style={{ backgroundColor: '#0003' }}>
                <ArrowRight style={{ fontSize: 48, color: '#FFF' }} />
              </Avatar>
            }
            hideDetail
            type={postType}
            onClickVideo={(url) => {
              setVideoState((state) => ({
                ...state,
                open: true,
                url,
              }));
            }}
            loading={initLoading}
          />
          {loadMoreAble && filteredPosts().length > 0 && (
            <Box
              display="flex"
              justifyContent="center"
              my={2}
              position="relative"
            >
              <Button
                className={moreButton}
                variant="contained"
                color="secondary"
                onClick={handleClickShowMore}
                disabled={loading}
              >
                แสดงเพิ่ม
              </Button>
              {loading && (
                <CircularProgress size={26} className={loadProgress} />
              )}
            </Box>
          )}
        </Section>
      </Container>
      <PreFooter />
      <Footer />
    </>
  );
};

export default Video;
